<template>
  <modal ref="modal" :close-on-mask-click="true" v-model="showModal">
    <div slot="title" class="mt-8">
      Answers from
      <a
        v-if="program.type === 'PROFILE' || program.type === 'BOTH'"
        :href="getStartupProfilePageLink(application.startup_id)"
        target="_new"
        >{{ application.startup_name }}</a
      >
      <span v-else>{{ application.startup_name }}</span>

      <a
        v-if="program.type === 'PROFILE' || program.type === 'BOTH'"
        :href="getStartupProfilePageLink(application.startup_id)"
        class="pull-right"
        target="_new"
      >
        <el-button target="_new" size="mini">
          Profile
        </el-button>
      </a>
    </div>
    <div>
      <ProgramForm
        ref="form"
        :editable="false"
        :questions="program.questions"
      />

      <hr />
      <ApplicationRating />

      <div class="form-group">
        <label class="control-label">Accepted?</label>
        <div class="row">
          <div class="col-sm-12 col-md-6 col-lg-4">
            <el-radio-group
              v-model="accepted"
              size="small"
              :disabled="acceptedInProgress || isAdmin"
              v-loadcover="acceptedInProgress"
            >
              <el-radio-button label="YES" />
              <el-radio-button label="NO" />
              <el-radio-button label="MAYBE" />
            </el-radio-group>
          </div>
        </div>
      </div>
    </div>

    <div slot="footer">
      <button type="button" class="btn btn-default" @click="showModal = false">
        Close
      </button>
    </div>
  </modal>
</template>

<script>
import Modal from '../../components/common/Modal.vue'
import { mapState } from 'vuex'
import ApplicationRating from 'modules/dashboard-organizer/ApplicationRating.vue'
import ProgramForm from 'modules/dashboard-organizer/ProgramForm.vue'

export default {
  components: { Modal, ApplicationRating, ProgramForm },
  data() {
    return {
      acceptedInProgress: false,
      showModal: false,
    }
  },
  computed: {
    ...mapState({
      fetchInProgress: (state) =>
        state.organizationProgramApplicationDetails.fetchInProgress ||
        state.organizationProgramDetails.fetchInProgress,
      application: (state) =>
        state.organizationProgramApplicationDetails.application,
      program: (state) => state.organizationProgramDetails.program,
      isAdmin: (state) => state.user.data.isAdmin,
    }),
    title() {
      return `Answers from: ${this.application.startup_name}`
    },
    accepted: {
      get() {
        return this.application.accepted
      },
      async set(value) {
        if (this.isAdmin) return
        this.acceptedInProgress = true
        try {
          await this.$store.dispatch(
            'organizationProgramApplicationDetails/saveAccepted',
            value,
          )
          await this.$store.dispatch(
            'organizationProgramApplications/silentFetch',
            {
              organizationId: this.application.organization_id,
              programId: this.application.program_id,
            },
          )
        } finally {
          this.acceptedInProgress = false
        }
      },
    },
  },
  methods: {
    async open({ organizationId, programId, applicationId }) {
      this.$store.commit('organizationProgramApplicationDetails/CLEAR')
      // Clear current answers
      this.showModal = true
      await this.$nextTick(async () => {
        const form = this.$refs && this.$refs['form']
        const answers = {}
        this.program.questions.forEach((q) => {
          answers[q.id] = { value: '', selected: [] }
        })
        if (this.showModal) {
          form.setAnswers(answers)
          const application = await this.$store.dispatch(
            'organizationProgramApplicationDetails/fetch',
            {
              organizationId,
              programId,
              applicationId,
            },
          )
          form.setAnswers(application.answers)
        }
      })
    },
    getStartupProfilePageLink(startupId) {
      return this.$router.resolve({
        name: 'publicStartupProfile',
        params: { slug: startupId },
      }).href
    },
  },
}
</script>

<style lang="scss" scoped>
.modal-body {
  .actions {
    position: absolute;
    right: 10px;
    top: 10px;
  }
}
</style>
